import { Float32BufferAttribute, BufferGeometry } from 'three';

class Triangle extends BufferGeometry {
  constructor() {
    super();

    this.setIndex([2, 1, 0]);

    this.addAttribute('position', new Float32BufferAttribute(
      [
        -1, -1, 0,
        -1, 4, 0,
        4, -1, 0,
      ], 3,
    ));
  }
}

const tri = new Triangle();

export default tri;
